import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="relative py-24 bg-pac-navy overflow-hidden border-t-4 border-pac-red" data-id="element-47" data-mp="3ucdq8aqe3kqz">
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-48" data-mp="c6slrkigseef" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-49" data-mp="m4or1voq0f4m">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-50" data-mp="h5vimhoajebb">
          <h2 className="font-serif text-4xl md:text-6xl font-bold text-white mb-6 drop-shadow-md" data-id="element-51" data-mp="14uofcgcqlq6z">
            Arizona Cities Need{' '}
            <span className="text-pac-gold" data-id="element-52" data-mp="zy6dppcpe7yv">Your Voice.</span>
          </h2>
          <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto font-light" data-id="element-53" data-mp="2c5px7w5vve2p">
            Stand with AZ City PAC to protect local authority and advance
            stronger, safer, more resilient communities across Arizona.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-54" data-mp="2m5724bdb9nxm">
            <a href="#donate" className="w-full sm:w-auto bg-pac-red hover:bg-red-800 text-white px-10 py-5 rounded font-bold text-xl uppercase tracking-wider transition-all shadow-[0_0_20px_rgba(185,28,28,0.4)] hover:shadow-[0_0_30px_rgba(185,28,28,0.7)] transform hover:-translate-y-1" data-id="element-55" data-mp="2qzufbe2v6vww">
              Contribute Now
            </a>
            <a href="#mission" className="w-full sm:w-auto bg-transparent border-2 border-slate-500 text-slate-300 hover:border-white hover:text-white px-10 py-5 rounded font-bold text-xl uppercase tracking-wider transition-all" data-id="element-56" data-mp="39r3ua2vemcvv">
              Learn More
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}